import React from 'react';
import graphql from 'babel-plugin-relay/macro';
import QueryRenderer from '../../../../../shared/relay/QueryRenderer';
import SamlForm from './SamlForm';

const SamlTab = props => {
  return (
    <QueryRenderer
      query={graphql`
        query SamlTabQuery {
          organization {
            ...SamlForm_organization
          }
        }
      `}
      variables={{}}
      render={relayProps => <SamlForm organization={relayProps.organization} {...props} />}
    />
  );
};

export default SamlTab;
